/**
 * @author Karthik <karthik.x@314ecorp.com>
 * @description Roles for Jeeves
 */

export const JEEVES_ADMIN_ROLE = '_JEEVESALL';

export const FEATURES_ROLES = {
	allowStandaloneLaunch: '_allow-standalone-launch',
	accessAnalytics: '_access-analytics',
	accessBroadcasts: '_access-broadcast',
	allowViewAssets: '_allow-view-asset',
	accessManageAssignment: '_access-assignment',
	accessSettings: '_access-setting',
	accessUserList: '_access-user-list',
	canManageUser: '_can-manage-user',
} as const;

export const ACTION_ROLES = {
	allowAddEditAssets: '_allow-add-edit-asset',
	allowPublishUnpublishAssets: '_allow-publish-asset',
	allowDeleteAssets: '_allow-delete-asset',
	allowReviewAssets: '_allow-review-asset',
} as const;

type TFeaturesRoles = (typeof FEATURES_ROLES)[keyof typeof FEATURES_ROLES];
type TActionRoles = (typeof ACTION_ROLES)[keyof typeof ACTION_ROLES];

export type TAllRoles = TFeaturesRoles | TActionRoles | typeof JEEVES_ADMIN_ROLE;
